import React from "react";
import { CloseIcon } from "../../../atoms/icons/close";
import { SlideUpModal } from "./SlideUpModal";
import { FixedIcon } from "../../../atoms/icons/fixed";
import { ArmIcon } from "../../../atoms/icons/arm";
import { addTrailingZeroes } from "../../../util/addTrailingZeroes";
import { dollarFormatter } from "../../../util/dollarFormatter";
import { CancelButton } from "./CancelButton";
import { RemoveButton } from "./RemoveButton";
import { RemoveQuoteContainer } from "./ui-utils";

export const RemoveModal = ({
  open,
  onClose,
  amortizationType,
  loanTerm,
  term,
  rate,
  apr,
  monthlyPayment,
  setComparedId,
  isComparedIds,
  id,
}) => {
  const handleRemove = () => {
    setComparedId(isComparedIds.filter((existingId) => existingId !== id));
    onClose();
  };

  return (
    <SlideUpModal
      open={open}
      onClose={onClose}
      direction="up"
      in
      mountOnEnter
      unmountOnExit
    >
      <div className="add-modal">
        <div className="remove-modal-wrapper">
          <RemoveQuoteContainer>
            Remove quote from comparison?
          </RemoveQuoteContainer>
          <div className="add-modal-row">
            <div className="quote-card-mobile-modal">
              {amortizationType === "Fixed" ? (
                <div className="quote-card-icon-wrapper">
                  <FixedIcon fill="#ff0043" width="40px" height="40px" />
                  <span className="quote-title">Fixed</span>
                  <span>Conventional</span>
                </div>
              ) : (
                <div className="quote-card-icon-wrapper">
                  <ArmIcon fill="#ff0043" width="40px" height="40px" />
                  <span className="quote-title">ARM</span>
                  <span>Conventional</span>
                </div>
              )}
              <div className="item-wrapper">
                Term
                <div className="large bold">
                  {amortizationType === "Fixed"
                    ? `${loanTerm} year`
                    : `${term}/6`}
                </div>
              </div>
              <div className="item-wrapper">
                Rate
                <div className="large bold">{addTrailingZeroes(rate)}%</div>
              </div>
              <div className="item-wrapper">
                APR
                <div className="large bold">{addTrailingZeroes(apr)}%</div>
              </div>
              <div className="item-wrapper">
                Monthly Payment
                <div className="large bold">
                  {dollarFormatter(Math.round(monthlyPayment))}
                </div>
              </div>
            </div>
          </div>
          <div className="button-row">
            <CancelButton handleClick={onClose} />
            <RemoveButton handleClick={handleRemove} />
          </div>
        </div>

        <div className="close-button" onClick={onClose}>
          <CloseIcon />
        </div>
      </div>
    </SlideUpModal>
  );
};
